import React, { useState } from 'react';
import { Tooltip, Dropdown, Menu } from "antd";
import styles from './scss/attachedfile.module.scss';
import { URButton } from '../../../../shared/widgets/button';
import { useSelector } from 'react-redux';
//import { transcriptUpload, updateFiles } from '../../../../../context/actions/socket';
import { Modal } from '../model';
import { init_ASR } from '../../../../models/callModel';
import store from '../../../../context/store/store';
import axios from 'axios';
import { automatedFilesUpload, removeAttachedFiles } from '../../../../base/callService/asrTTS';
import { setIcon, toastInformation } from '../../../../base/callService/common';
import { config } from 'unifiedring-sdk/dist/base/config';

let modalRef: any;
type TranscriptContainerState = {
  openAttachFile: boolean;
  pdfViewer: string;
  pdfName:string;
  pdfURL: string;
  visible: boolean;
}

export const AttachedFiles = () => {
  const [getScriptInfo, setScriptInfo] = useState < TranscriptContainerState >
  ({
    openAttachFile: false, pdfViewer: "",
    pdfName: "", pdfURL: "", visible: false
  });
  const { closeCaption }:init_ASR = useSelector((state:init_ASR) => state);
  
  // const stopClose = () => {
  //   setScriptInfo({...getScriptInfo, openAttachFile:false});
  // };

  const openKeyword = () => {
    setScriptInfo({...getScriptInfo, openAttachFile:true});
  };

  const handleMenuClick = () => {
    setScriptInfo({ ...getScriptInfo, visible: false });
  };

  const handleVisibleChange = (flag:any) => {
    setScriptInfo({...getScriptInfo, visible:flag});
  };

  const attachFiles = async(e: any) => {
    let choosedFile: any = e.target.files;
    let token:string = store.getState().loginReducer.token;
    // let fileLength: any= closeCaption.files||[];
    // if(e.target.files && fileLength.length<=10){
      
    //   for (let i = 0; i <choosedFile.length; i++) {
    //     let filesinfo:any = {};
    //     filesinfo.filename = choosedFile[i].name;
    //     filesinfo.mimetype = choosedFile[i].type;
    //     filesinfo.geturl =  window.URL.createObjectURL(choosedFile[i]);
    //     //const retrieved = URL.getBlobFromObjectURL(filesinfo.geturl);
    //     // console.log("url--",retrieved);
    //     filesinfo.size =choosedFile[i].size;
    //     filesinfo.targetFile = choosedFile[i];
    //     automatedFilesUpload(filesinfo);
    //   }
    // }
    // else {
    //   toastInformation("unable to send more than 10 files", "success");
      
    // }

    let formData = new FormData();
    for (let i = 0; i < choosedFile.length; i++) {
      formData.append("doc", choosedFile[i]);
    };
    const url: string =  "https://urapi.worktual.co.uk/urchat/v2/upload/files";
    var authkey = {
      "Content-Type": "application/json",
      Authorization: token
    };
    await axios.post(url, formData, { headers: authkey }).then((response: any) => {
      if (response.data.statusCode === 200) {

        let { files } = closeCaption;
        response?.data?.files?.forEach(async (element: any) => {
          let data: any = {};
          data.fileUrl = element.geturl;
          data.fileName = element.filename;
          data.fileSize = element.size;
          data.mimeType = element.mimetype;
          files.push(data);
          automatedFilesUpload(files);
        });
        // if (files[0] && Array.isArray(files) && files.length !== 0) {
        //   //files.push(response.data.files[0]);
        //   automatedFilesUpload(files);
        // }
      }
    });


  };
 
  const bytesToSize = (bytes: any) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 'n/a';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
    if (i === 0) return `${bytes} ${sizes[i]})`;
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
  };


  const modalRefClose = () =>{
    modalRef.close();
  };

  const filePreview = (fileNumber: number) => {
    console.log("index-----", fileNumber);
    let file: any = closeCaption.files || [];
    const pdfURL =file[fileNumber];
    const driveURL  = `https://drive.google.com/viewerng/viewer?embedded=true&url=${pdfURL.fileUrl}#toolbar=0&scrollbar=0`;
    setScriptInfo({
      ...getScriptInfo, pdfViewer:driveURL, pdfName:file[fileNumber].fileName,
      pdfURL: pdfURL, openAttachFile:false, visible:false
    });
    modalRef.open();
    // const mapFile = closeCaption.files.filter((value:any, indexs:number)=> indexs===index);
    // const pdfURL =mapFile[0].geturl;
    // const driveURL  = `https://drive.google.com/viewerng/viewer?embedded=true&url=${pdfURL}#toolbar=0&scrollbar=0`;
    // setScriptInfo({...getScriptInfo, pdfViewer:driveURL, pdfName: mapFile[0].filename,
    //   pdfURL: pdfURL, openAttachFile: false, visible:false});
    // modalRef.open();
  };

  const attachdocument = (
    <Menu className={styles.callsSummaryView}>
      <p>Attach File(s)</p>
      <div className={`scroller ${styles.attachscroll}`}>
        {closeCaption.files.map((value: any, index: any) =>
          <>
            <div className={styles.callsSummaryFiles}>
              <div className={styles.callsSummaryList}>
                <div className={styles.callsSummaryImage}><img src={setIcon(value.mimeType)} alt="" /></div>
                <div className={styles.callsSummaryDetails}>
                  <span className={styles.callsSummaryName}>{value.fileName}</span>
                  <span className={styles.callsSummaryDt}>{bytesToSize(value.fileSize)}file</span>
                </div>
                <span onClick={() => filePreview(index)} className={styles.searchbtn}></span>
                <Tooltip placement="topRight" title="Remove File" >
                  <span className={`icon_close ${styles.closebtn}`}
                    onClick={() => removeAttachedFiles(index)}></span></Tooltip>
              </div>
            </div>
          </>
        )
        }
      </div>
      <div className={styles.callsAddDocument}>
        <input type="file" id="upload"  onChange={(e)=>attachFiles(e)} hidden multiple/>
        <label htmlFor="upload" className={styles.customUpload}>
          <span className="icon_Newdoc"></span>
          New Documents
        </label>
      </div>

      <Modal  ref={(ref) => (modalRef = ref)} className="imagepreviewmodal">
        <div className="modalheaders">
          <h2>{getScriptInfo.pdfName}</h2>
          <ul>
            <li><Tooltip placement="top" title={'Close'}>
              <span className="icon_close" onClick={modalRefClose}>
              </span></Tooltip></li>
          </ul>
        </div>
        <div className="chatNoteImgContent">
          <iframe
            src={getScriptInfo.pdfViewer}
            frameBorder="0"
            scrolling="auto"
            height="400"
            width="100%"
            title='#'
          ></iframe>
        </div>
      </Modal>

      <div className={styles.callsSummaryButtonView }>
        <URButton className={styles.callsSummaryLeftButton} onClick={handleMenuClick} name='Cancel'/>
        <URButton className={styles.callsSummaryRightButton} onClick={handleMenuClick} name='Add'/>
      </div>

    </Menu>
  );

  return (   <>
    <Dropdown placement="bottomRight"
      className={styles.callsSummaryBtn}
      overlay={attachdocument} trigger={['click']}
      onVisibleChange={handleVisibleChange}
      visible={getScriptInfo.visible}>
        <Tooltip placement="top" title="Attach Document"><span className="icon_attach" onClick={openKeyword}></span></Tooltip>
      
    </Dropdown>
  </>);
};